import TOP_BARS from '@/utils/topBars';
import FOOTERS from '@/utils/footers';
import ROLES from '@/utils/roles';
let studentRoutes = [
  {
    path: '/virtual-campus',
    name: 'virtual-campus',
    meta: {
      title: 'HSYLC 2022  Virtual Campus',
      topBar: TOP_BARS.NULL,
      footer: FOOTERS.NULL
    },
    component: () => import('../../views/Campus')
  },
  /**
   * @function /badges
   * @desc 成就系统 徽章
   * @param {Component} Badges /views/Badges
   * @param {Name} pathname badges
   */
  {
    path: '/badges',
    name: 'badges',
    meta: {
      title: '成就系统'
    },
    component: () => import('../../views/Badges')
  },
  {
    path: '/student/house/video/creater',
    name: 'student-house-video-creater',
    meta: {
      topBar: TOP_BARS.NULL,
      footer: FOOTERS.NULL
    },
    component: () => import('../../views/Campus/Pages/House/Creater')
  },
  {
    path: '/cluster',
    name: 'cluster',
    meta: {
      topBar: TOP_BARS.NULL,
      footer: FOOTERS.NULL
    },
    component: () => import('../../views/Cluster')
  }
];
let teacherRoutes = [
  {
    path: '/virtual-campus/teacher',
    name: 'virtual-campus-teacher',
    meta: {
      title: 'HSYLC 2022  Virtual Campus - Instructor',
      topBar: TOP_BARS.NULL,
      footer: FOOTERS.NULL
    },
    redirect: { name: 'dashboard' }
  },
  /**
   * @function /badges/teacher
   * @desc 成就系统 徽章
   * @param {Component} BadgesTeacher /views/Badges/Teacher
   * @param {Name} pathname badges-teacher
   */
  {
    path: '/badges/teacher',
    name: 'badges-teacher',
    meta: {
      title: '成就系统'
    },
    component: () => import('../../views/Badges/Teacher')
  },
  {
    path: '/teacher/house/video/creater',
    name: 'teacher-house-video-creater',
    meta: {
      topBar: TOP_BARS.NULL,
      footer: FOOTERS.NULL
    },
    component: () => import('@/views/teacher/House/VideoCreator')
  }
];
studentRoutes = studentRoutes.map(item => {
  let ret = Object.assign({}, item);
  ret.meta = Object.assign({}, ret.meta, {
    role: ROLES.STUDENT
  });
  return ret;
});
teacherRoutes = teacherRoutes.map(item => {
  let ret = Object.assign({}, item);
  ret.meta = Object.assign({}, ret.meta, {
    role: ROLES.TEACHER
  });
  return ret;
});
export default [...studentRoutes, ...teacherRoutes];
